import { VIEW_MANAGEMENT } from 'store/types';

function hidePreloader() {
  return {
    type: VIEW_MANAGEMENT.HIDE_PRELOADER,
  };
}

export default hidePreloader;
